import { logger } from './logger';

export const getInitialData = (): InitialState => {
  try {
    const script = document.getElementById('ssr-initial-data');

    return JSON.parse(script.textContent);
  } catch (error) {
    logger.log({
      message: 'fail parse initial data',
      error,
    });
  }
};

class RenderModel {
  private readonly model: InitialState;
  private mediaAuthToken: string;

  constructor(model: InitialState) {
    this.model = model as InitialState;
    this.mediaAuthToken = '';
  }

  get() {
    return this.model;
  }

  getLocale() {
    return this.model?.locale;
  }

  getUserId() {
    return this.model?.userId;
  }

  getMediaToken() {
    return this.mediaAuthToken;
  }

  setMediaToken(token: string) {
    this.mediaAuthToken = token;
  }

  getExperiments() {
    return this.model?.experiments;
  }

  isWidget(): boolean {
    return this.model?.isWidget;
  }
}

export const renderModel = new RenderModel(getInitialData());
